import services from 'api/services';
import { ObjectException, logError } from 'global/errors';
import { isValidEmail } from 'functions/stringValidation';
import { trackFbEvents } from 'functions/fbPixel';

import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE, SIGNUP_CLEAR_ERROR, SIGNUP_CLEAR_STATE } from '../constants';
import { sendAnalytics } from 'functions/sendAnalytics';

const { AuthService } = services;

export const clearState = () => (dispatch) => {
  dispatch({ type: SIGNUP_CLEAR_STATE });
};

export const clearError = () => (dispatch) => {
  dispatch({ type: SIGNUP_CLEAR_ERROR });
};

export const signup =
  (email, company, name, isCompany, isAgreementAgreed, isGDPRAgreed, campaignSource) => async (dispatch) => {
    try {
      if (!isValidEmail(email)) {
        throw new ObjectException(
          {
            de: 'Email is not valid.',
            en: 'Email is not valid.',
            sv: 'Emailen är inte giltig.',
          },
          'INVALID_EMAIL'
        );
      }
      dispatch({ type: SIGNUP_REQUEST });
      await AuthService.signup(email, company, name, isCompany, isAgreementAgreed, isGDPRAgreed, campaignSource);
      sendAnalytics('signup', '', isCompany ? false : true);
      trackFbEvents('Signup');
      dispatch({ type: SIGNUP_SUCCESS });
    } catch (ex) {
      logError(ex);
      dispatch({ type: SIGNUP_FAILURE, error: ex.message });
    }
  };
